import {
  Slider as MuiSlider,
  Box,
  Typography,
  FormHelperText,
  FormControl,
} from "@mui/material";

const styles = (theme) => {
  return {
    display: "flex",
    alignItems: "center",
    width: "100%",
    "& .slider-space": {
      width: "15%",
    },
    "& .slider-wrapper": {
      width: "90%",
      "& .MuiSlider-root": {
        marginBottom: "0px",
        padding: "10px 0",
      },
      "& .MuiSlider-markLabel": {
        top: "20px",
        color: theme.palette.primary.main,
        fontWeight: 500,
      },
      "& .MuiSlider-rail": {
        background:
          "linear-gradient(90deg, rgba(0,64,87,0.4) 0%, rgba(0,64,87,1) 100%)",
        opacity: "unset",
        height: "8px",
        borderRadius: 0,
      },
      "& .MuiSlider-mark": {
        backgroundColor: "white",
        width: "1px",
        height: "8px",
      },
      "& .MuiSlider-track": {
        backgroundColor: "#F9B426",
        borderColor: "#F9B426",
        height: "6px",
      },
      "& .MuiSlider-thumb": {
        backgroundColor: "white",
        border: "4px solid #F9B426",
      },
    },
  };
};

const Slider = ({
  label,
  value,
  name,
  onChange,
  options,
  min,
  max,
  endLabel,
  disabled,
  error,
  helperText,
}) => {
  return (
    <FormControl size="small" disabled={disabled} error={error}>
      <Box className="slider-switch" sx={(theme) => styles(theme)}>
        <Typography variant="body2" className="slider-space">
          {label}
        </Typography>
        <Box className="slider-wrapper">
          <MuiSlider
            name={name}
            step={null}
            min={min}
            max={max}
            marks={options}
            value={value}
            onChange={onChange}
            disabled={disabled}
          />
        </Box>
        {endLabel && (
          <Typography variant="body2" className="slider-space" align="right" ml={3}>
            {endLabel}
          </Typography>
        )}
      </Box>
      {error && helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
};

export default Slider;
